import React, { FC, useCallback, useEffect, useState } from 'react';
import { FullBoatDetail } from 'src/types/boat/BoatDetail';
import Modal from 'src/common/components/Modal';
import Button from 'src/common/components/Button';
import RadioButton from 'src/common/components/inputs/RadioButton';
import SimpleBoatListingItem from 'src/calendar/components/SyncCalendarPage/components/SimpleBoatListingItem';
import s from './ListingSelectorModal.module.scss';

const { Header } = Modal;

type ListingSelectorModalProps = {
  close: () => void;
  isOpen: boolean;
  list: FullBoatDetail[];
  initialBoatId: string;
  updateSelectedBoat: (boatId: string) => void;
};

const ListingSelectorModal: FC<ListingSelectorModalProps> = ({
  close,
  isOpen,
  list,
  initialBoatId,
  updateSelectedBoat,
}) => {
  const [selectedBoatId, setSelectedBoatId] = useState<string>(initialBoatId);

  const handleSelect = useCallback(() => {
    updateSelectedBoat(selectedBoatId);
    close();
  }, [updateSelectedBoat, selectedBoatId, close]);

  // Reset the selected boat when the modal is opened.
  useEffect(() => {
    if (isOpen) {
      setSelectedBoatId(initialBoatId);
    }
  }, [isOpen, initialBoatId]);

  return (
    <Modal
      label="Select a boat"
      name="select-boat"
      closeModal={close}
      modalOpen={isOpen}
      classNameModifier="syncCalendar"
      size="large"
    >
      <Header>
        <h5 className={s.heading}>
          Select Listing
        </h5>
        <p className={s.description}>
          Select a listing to sync with Google Calendar.
        </p>
      </Header>
      <div className={s.body}>
        {list.map((boat) => (
          <SimpleBoatListingItem
            key={boat.id}
            photoUrl={boat.photo_url}
            headline={boat.headline}
            onClick={() => setSelectedBoatId(boat.id)}
          >
            <RadioButton
              input={{
                checked: selectedBoatId === boat.id,
                onChange: () => {
                  setSelectedBoatId(boat.id);
                },
              }}
            />
          </SimpleBoatListingItem>
        ))}
      </div>
      <div className={s.footer}>
        <Button
          classNameModifier="noMargin secondary"
          type="button"
          onClick={close}
          fullWidth
        >
          Cancel
        </Button>
        <Button
          classNameModifier="noMargin"
          type="button"
          onClick={handleSelect}
          fullWidth
        >
          Select
        </Button>
      </div>
    </Modal>
  );
};

export default ListingSelectorModal;
